import {Settings} from '../../interfaces/core/settings';
import {Injectable} from '@angular/core';
import {StorageService} from './storage.service';


@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  public static _settings: Settings = null;

  static get settings(): Settings {
    return SettingsService._settings;
  }

  constructor() {
  }

  public async init(): Promise<void> {
    SettingsService._settings = await StorageService.getItem('settings');
  }

  public async setSettings(settings: Settings) {
    SettingsService._settings = {...settings};
    await StorageService.setItem('settings', settings);
  }
}